module.exports = __webpack_public_path__ + "static/img/media5.9cb7ea7.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/media5.png
// module id = LBZq
// module chunks = 7